import { Button, Dropdown, Image, Menu, Space, Typography } from "antd";
import React, { FC, useCallback } from "react";
import ConnectWalletGraphic from "@dewo/app/assets/connect-wallet.svg";
import { OnboardingUSPs } from "./OnboardingUSPs";
import { UserPromptStepComponentProps } from "../../types";
import { WalletConnectAuthButton } from "@dewo/app/containers/auth/buttons/WalletConnectAuthButton";
import { MetamaskAuthButton } from "@dewo/app/containers/auth/buttons/MetamaskAuthButton";
import { PhantomAuthButton } from "@dewo/app/containers/auth/buttons/PhantomAuthButton";

const usps = [
  "💰   Get paid for tasks and bounties you complete",
  "🔑   Join token/NFT gated workspaces",
];

export const OnboardingConnectWallet: FC<UserPromptStepComponentProps> = ({
  active,
  onNext,
}) => {
  const handleNext = useCallback(() => onNext(), [onNext]);
  return (
    <>
      <Typography.Title level={2} style={{ textAlign: "center" }}>
        Connect your Wallet
      </Typography.Title>
      <Image
        src={ConnectWalletGraphic.src}
        preview={false}
        style={{ width: "60%" }}
        className="mx-auto"
      />
      <OnboardingUSPs usps={usps} />
      <Space
        direction="vertical"
        className="mx-auto w-full"
        style={{ display: "flex", maxWidth: 368, marginBottom: 16 }}
      >
        <MetamaskAuthButton
          children="Metamask"
          size="large"
          block
          type="primary"
          name="Onboarding Wallet: connect Metamask"
          onAuthed={handleNext}
        />
        <WalletConnectAuthButton
          children="WalletConnect"
          size="large"
          block
          name="Onboarding Wallet: connect WalletConnect"
          onAuthed={handleNext}
        />
        <Dropdown
          placement="bottom"
          trigger={["click"]}
          {...(!active && { visible: false })}
          overlay={
            <Menu>
              <PhantomAuthButton
                children="Phantom"
                size="large"
                block
                type="text"
                name="Onboarding Wallet: connect Phantom"
                onAuthed={handleNext}
              />
            </Menu>
          }
        >
          <Button size="large" block>
            More Options
          </Button>
        </Dropdown>
      </Space>
      <Button
        type="text"
        style={{ alignSelf: "center" }}
        className="text-secondary"
        name="Onboarding Wallet: skip"
        onClick={handleNext}
      >
        Skip
      </Button>
    </>
  );
};
